/**
 * Educator verdicts on a row's hints, rendered apart from the student's thumbs.
 *
 * Deliberately a different shape from the student rating cell (outlined chips,
 * "review" wording) — a reviewer scanning the table has to be able to tell at a
 * glance whose judgement they are looking at, since the two routinely disagree
 * and that disagreement is the signal.
 */

export interface ReviewCounts {
  reviewedGood: number;
  reviewedPoor: number;
  unreviewed: number;
}

export function ReviewCell({ row }: { row: ReviewCounts }) {
  const done = row.reviewedGood + row.reviewedPoor;
  if (done === 0) {
    return (
      <span className="hintq-muted" title={`${row.unreviewed} hint(s) not yet reviewed`}>
        {row.unreviewed > 0 ? 'not reviewed' : '—'}
      </span>
    );
  }
  return (
    <div className="hintq-reviewcell" title={
      `${row.reviewedGood} judged good, ${row.reviewedPoor} judged poor` +
      (row.unreviewed > 0 ? `, ${row.unreviewed} not yet reviewed` : '')
    }>
      {row.reviewedGood > 0 && <span className="hintq-reviewchip is-good">👍 {row.reviewedGood}</span>}
      {row.reviewedPoor > 0 && <span className="hintq-reviewchip is-poor">👎 {row.reviewedPoor}</span>}
      {row.unreviewed > 0 && <span className="hintq-reviewchip is-todo">+{row.unreviewed}</span>}
    </div>
  );
}
